<style>
    a.disabled {
        pointer-events: none;
        cursor: not-allowed;
    }
    .pagination > .disabled {
        background: #fff !important;
        border: none !important;
    }
    .pagination>.disabled>a {
        background: #f5f5f5 !important;
        border: none !important;
    }
</style>
<template>
    <div>
        <div class="page_title gradient_overlay" style="background: url(/assets/images/page_title_bg.jpg);">
            <div class="container">
                <div class="inner">
                    <h1 v-lang.blog></h1>
                    <ol class="breadcrumb">
                        <li>
                            <router-link to="/" v-lang.inicio></router-link>
                        </li>
                        <li v-lang.blog></li>
                    </ol>
                </div>
            </div>
        </div>

        <!-- =========== MAIN ========== -->
        <main class="blog">
            <div class="container">
                <div class="row">
                    <div class="col-md-9">
                        <!-- ITEM -->
                        <article class="blog_list" v-for="post in posts">
                            <!--<figure>
                                <a href="blog-post.html" class="hover_effect h_link h_blue">
                                    <img src="images/blog/blog_post1.jpg" class="img-responsive" alt="Image">
                                </a>
                            </figure>-->
                            <div class="details">
                                <h2>
                                    <a>{{post.title}}</a>
                                </h2>
                                <div class="info">
                                    <span class="meta_part">
                                        <a>
                                            <i class="fa fa-user"></i>
                                            <span v-if="post.author">
                                                {{post.author.firstname}} {{post.author.lastname}}
                                            </span>
                                        </a>
                                    </span>
                                    <span class="meta_part">
                                        <a href="#">
                                            <i class="fa fa-calendar"></i>
                                            {{formatDate(post.createdAt)}}
                                        </a>
                                    </span>
                                    <!--<span class="meta_part"><a href="#"><i class="fa fa-comment-o"></i>68 Comments</a></span>
                                    <span class="meta_part"><i class="fa fa-folder-open-o"></i><a href="#">News</a>, <a href="#">Events</a></span>-->
                                </div>
                                <div v-html="post.description"></div>
                                <!--<a class="button btn_blue " href="blog-post.html">
                                    <i class="fa fa-angle-double-right"></i>
                                    Ver más
                                </a>-->
                            </div>
                        </article>
                        <nav>
                            <ul class="pagination">
                                <li class="prev_pagination" :class="{disabled: currentPage <= 1}">
                                    <a @click.stop.prevent="goTo(currentPage - 1)">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                                </li>
                                <li v-for="page in pages" :class="{'active': page === currentPage}" :key="`blog_page_${page}`">
                                    <a @click.stop.prevent="goTo(page)">{{page}}</a>
                                </li>
                                <li class="next_pagination" :class="{disabled: currentPage >= lastPage}">
                                    <a @click.stop.prevent="goTo(currentPage + 1)">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-md-3">
                        <div class="sidebar">
                            <!--<aside class="widget">
                                <div class="search">
                                    <form method="get" class="widget_search">
                                        <input type="search" placeholder="Start Searching...">
                                        <button class="search_btn" id="searchsubmit" type="submit">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </form>
                                </div>
                            </aside>
                            <aside class="widget">
                                <h4>CATEGORIES</h4>
                                <ul class="categories">
                                    <li><a href="#">Zante Hotel Rooms <span class="num_posts">51</span></a></li>
                                    <li><a href="#">Accommodation <span class="num_posts">24</span></a></li>
                                    <li><a href="#">Restaurant <span class="num_posts">9</span></a></li>
                                    <li><a href="#">Swimming Pool <span class="num_posts">12</span></a></li>
                                    <li><a href="#">Holidays in Greece <span class="num_posts">28</span></a></li>
                                    <li><a href="#">Events <span class="num_posts">5</span></a></li>
                                    <li><a href="#">News <span class="num_posts">5</span></a></li>
                                </ul>
                            </aside>-->
                            <aside class="widget">
                                <last-posts></last-posts>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>
<script>
    import moment from 'moment';
    import axiosInstance from '../../HttpRequest';

    let LastsPosts = require('../singleRoom/widgets/lastPosts.vue');

    export default {
        components: {
          'last-posts': LastsPosts,
        },
        data() {
          return {
            $language: '',
            currentPage: 1,
            posts: [],
            total: 0,
            perPage: 5,
          };
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                axiosInstance.get(`/post/count?where={"lang":"${self.$language}"}`).then((resp) => {
                    self.total = resp.data.count;
                });
            });
            self.getPosts();
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        methods: {
          formatDate(date) {
            return moment(date).format('MMM DD, YYYY');
          },
          getPosts() {
            const self = this;
            const { perPage, currentPage } = this;
            axiosInstance.get(`/post?populate=author&sort=id DESC&limit=${perPage}&skip=${(currentPage - 1) * perPage}&where={"lang":"${self.$language}"}`).then((resp) => {
              self.posts = resp.data;
            });
          },
          goTo(page) {
            if (page >= 1 && page <= this.lastPage) {
              this.currentPage = page;
              this.getPosts();
            }
          },
        },
        computed: {
          lastPage() {
            const { total, currentPage, perPage } = this;
            if (total > 0) {
              return Math.round(total/perPage);
            }
            return 1;
          },
          pages() {
            const numbers = [1];
            const { lastPage } = this;
            if (lastPage > 1) {
              for(let i = 2; i <= lastPage; i++) {
                numbers.push(i);
              }
            }
            return numbers;
          },
        },
    }
</script>


// WEBPACK FOOTER //
// Blog.vue?c1f5592a